import * as React  from "react";
import { useState, useEffect } from 'react';
import axios from 'axios';

interface Image {
  id: number;
  personal_info_flg: boolean;
}

const PatientImages = (props) => {
  const [images, setImages] = useState([]);
  const [avatorImageId, setavatorImageId] = useState(props.avator_image_id);
  const [trashCandidateIds, setTrashCandidateIds] = useState([])
  const [deleteProtections, setDeleteProtections] = useState([])
  const smileLogo =  require("../../images/iconmonstr-smiley-2-240.png")

  useEffect(() => {
    async function fetchImages() {
      const images = await axios.get<Image[]>(
        '/api/internal/patients/images?patient_id=' + props.patient_id,
      );
      setImages(images.data);
      let delete_protection_images = images.data.filter(e => (e.personal_info_flg === true))
      setDeleteProtections(delete_protection_images.map(i => i.id))
    }
    fetchImages();
  }, []);

  const updateDeleteProtections = (image_id) => {
    let newDeleteProtections
    newDeleteProtections = [...deleteProtections, image_id]
    setDeleteProtections(newDeleteProtections)
  }

  const removeDeleteProtections = (image_id) => {
    let trashDeleteProtections
    trashDeleteProtections = deleteProtections.filter(e => !(e === image_id))
    setDeleteProtections(trashDeleteProtections)
  }

  const updateTrashCandidates = (image_id) => {
    let newTrashCandidates
    newTrashCandidates = [...trashCandidateIds, image_id]
    setTrashCandidateIds(newTrashCandidates)
  }

  const removeTrashCandidates = (image_id) => {
    let newTrashCandidates
    newTrashCandidates = trashCandidateIds.filter(e => !(e === image_id))
    setTrashCandidateIds(newTrashCandidates)
  }

  if (!props.can_edit_setting) {
    return (
      <div className="modal-patient-image-content">
        {images.map((image, i) => (
          <div key={i} className="modal-patient-image-box">
            <img src={image.s3_object_public_url}
                 key={i}>
            </img>
          </div>
        ))}
      </div>
    );
  };

  return(
    <>
      <div className="row">
        <br/>
        {images.map((image, i) => (
          <div key={i} className="col-xs-2 patient-image-box">
            <img src={image.s3_object_public_url}
                  key={i}
                  className="patient_image"
                  onClick={() => setavatorImageId(image.id)}></img>
            {image.id == avatorImageId && <img src={smileLogo} className="logo-on-image" />}
            {trashCandidateIds.indexOf(image.id) !== -1 && <span className="glyphicon glyphicon-remove"></span>}
            {deleteProtections.indexOf(image.id) !== -1 && <span className="glyphicon glyphicon-check checkicon-on-image"></span>}

            {image.id == avatorImageId ?
                          <a className="avator-set-link" onClick={() => setavatorImageId(0)}>
                          <img src={smileLogo} className="smile-logo" />
                          <span className="glyphicon-text">アバターを取り消す</span>
                       </a>
                       :
              <a className="avator-set-link" onClick={() => setavatorImageId(image.id)}>
               <img src={smileLogo}
                    className="smile-logo"/>
               <span className="glyphicon-text">アバターに設定</span>
              </a>
            }

            {deleteProtections.indexOf(image.id) === -1 ?
              <a className="glyphicon glyphicon-check"
                onClick={() => updateDeleteProtections(image.id)}>
                <span className="glyphicon-text">削除保護</span>
              </a> :
              <a className="glyphicon glyphicon-check"
                onClick={() => removeDeleteProtections(image.id)}>
                <span className="glyphicon-text">削除保護を取り消す</span>
              </a>
            }

            {trashCandidateIds.indexOf(image.id) === -1 ?
              <a className="glyphicon glyphicon-trash"
                onClick={() => updateTrashCandidates(image.id)}>
                <span className="glyphicon-text">削除する</span>
              </a> :
              <a className="glyphicon glyphicon-trash"
                onClick={() => removeTrashCandidates(image.id)}>
                <span className="glyphicon-text">削除を取り消す</span>
              </a>
            }

            <a href={image.s3_object_public_url} className="glyphicon glyphicon-download" download>
              <span className="glyphicon-text">ダウンロード</span>
            </a>
        　</div>
        ))}
      </div>
      <input type="hidden" name="m_patient_image[avator_image_id]" value={avatorImageId}></input>
      <input type="hidden" name="m_patient_image[delete_image_ids]" value={trashCandidateIds}></input>
      <input type="hidden" name="m_patient_image[delete_protection_image_ids]" value={deleteProtections}></input>
    </>
  )
}

export default PatientImages
